export default "__VITE_ASSET__3171d256__"